<template>
    <div>
        <q-dialog v-model="show" @hide="onClose">
            <!-- The card displayed when the accesses is empty -->
            <q-card v-if="isAccessesEmpty">
                <q-card-section>
                    <div class="text-h6">
                        {{ $t('No Extra Access To Grant') }}
                    </div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    {{
                        $t(
                            'You do not have extra accesses to grant to the target user.'
                        )
                    }}
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn
                        flat
                        label="OK"
                        @click="$emit('close', [])"
                        color="primary"
                        v-close-popup
                    ></q-btn>
                </q-card-actions>
            </q-card>
            <!-- The card when the accesses is not empty -->
            <q-card v-else class="q-pa-md" style="width: 90%">
                <q-card-section class="q-pt-none">
                    <q-form @submit="onSelect" ref="accessForm">
                        <div class="text-h6 q-mb-sm">
                            {{ $t('Select Assets') }}
                        </div>
                        <q-card bordered flat class="permission-card-section">
                            <q-card-section class="permission-card-section">
                                <q-scroll-area
                                    style="height: 500px; full-width"
                                    visible
                                    :bar-style="{
                                        backgroundColor: '#c7c3c3',
                                        width: '10px',
                                        opacity: 0.2
                                    }"
                                    :thumb-style="{
                                        borderRadius: '3px',
                                        backgroundColor: 'grey',
                                        width: '8px',
                                        opacity: 0.75
                                    }"
                                >
                                    <!-- access list -->
                                    <q-list
                                        v-for="(
                                            facility, index
                                        ) in grantAccessList"
                                        :key="facility.facility_id"
                                    >
                                        <q-item-section>
                                            <q-item-label
                                                header
                                                style="color: black"
                                            >
                                                <b>{{
                                                    facility.facility_name
                                                }}</b>
                                                <q-checkbox
                                                    v-model="
                                                        facility.select_all
                                                    "
                                                    @click="grantAll(facility)"
                                                    left-label
                                                    :label="$t('Grant all')"
                                                    dense
                                                    color="accent"
                                                    class="float-right q-mr-xs"
                                                >
                                                    <q-tooltip
                                                        style="font-size: 12px"
                                                    >
                                                        {{
                                                            $t(
                                                                'Grant all the accesses of this facility'
                                                            )
                                                        }}
                                                    </q-tooltip>
                                                </q-checkbox>
                                            </q-item-label>
                                        </q-item-section>

                                        <q-item dense>
                                            <q-item-section top>
                                                <q-item-label caption>{{
                                                    $t('Asset name')
                                                }}</q-item-label>
                                            </q-item-section>
                                            <q-item-section top>
                                                <q-item-label caption>{{
                                                    $t('Notification')
                                                }}</q-item-label>
                                            </q-item-section>
                                            <q-item-section top side>
                                                <q-item-label caption>{{
                                                    $t('Grant')
                                                }}</q-item-label>
                                            </q-item-section>
                                        </q-item>
                                        <q-item
                                            v-for="access in facility.accesses"
                                            :key="access.asset_name"
                                            dense
                                        >
                                            <q-item-section top>
                                                <q-item-label lines="1">{{
                                                    access.asset_name
                                                }}</q-item-label>
                                            </q-item-section>

                                            <q-item-section top>
                                                <q-item-label>
                                                    <q-toggle
                                                        v-model="
                                                            access.is_notified
                                                        "
                                                        :disable="
                                                            !access.is_selected
                                                        "
                                                        color="accent"
                                                        dense
                                                        size="sm"
                                                    >
                                                        <q-tooltip
                                                            v-if="
                                                                access.is_selected
                                                            "
                                                            style="
                                                                font-size: 12px;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    'Allow this user to receive notifications from the selected asset'
                                                                )
                                                            }}
                                                        </q-tooltip>
                                                        <q-tooltip
                                                            v-else
                                                            style="
                                                                font-size: 12px;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    'Cannot open notification unless access to asset is granted.'
                                                                )
                                                            }}
                                                        </q-tooltip></q-toggle
                                                    >
                                                </q-item-label>
                                            </q-item-section>

                                            <q-item-section top side>
                                                <q-item-label>
                                                    <q-checkbox
                                                        dense
                                                        v-model="
                                                            access.is_selected
                                                        "
                                                        @click="
                                                            grantOne(access)
                                                        "
                                                        color="accent"
                                                    >
                                                        <q-tooltip
                                                            style="
                                                                font-size: 12px;
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    'Grant access to the selected asset to the user.'
                                                                )
                                                            }}
                                                        </q-tooltip></q-checkbox
                                                    >
                                                </q-item-label>
                                            </q-item-section>
                                        </q-item>
                                        <q-separator
                                            inset
                                            spaced
                                            v-show="
                                                index !==
                                                grantAccessList.length - 1
                                            "
                                        ></q-separator>
                                    </q-list>
                                </q-scroll-area>
                            </q-card-section>
                        </q-card>

                        <br />
                        <div class="form__actions">
                            <q-btn
                                :label="$t('Select')"
                                type="submit"
                                class="float-right q-mb-sm"
                                color="primary"
                                text-color="white"
                                v-close-popup
                            />
                            <q-btn
                                :label="$t('Cancel')"
                                @click="onClose"
                                class="float-right q-mb-sm q-mr-sm"
                                outline
                                text-color="primary"
                            >
                            </q-btn>
                        </div>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
export default {
    name: 'GrantAccessDialog',
    emits: ['close'],
    props: {
        accesses: {
            type: Array,
            required: false
        }
    },
    watch: {
        accesses: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.initGrantAccessList();
                }
            }
        }
    },
    data() {
        return {
            show: true,
            grantAccessList: []
        };
    },
    computed: {
        /**
         * Check if the accesses is empty
         * @return {Boolean}
         */
        isAccessesEmpty() {
            return this.accesses.length === 0;
        }
    },
    methods: {
        /**
         * Initialize the grant access list by deep copying the accesses prop
         */
        initGrantAccessList() {
            this.grantAccessList = JSON.parse(JSON.stringify(this.accesses));
            // for each facility, define a 'select_all' field
            this.grantAccessList.forEach(facility => {
                facility['select_all'] = false;
            });
        },
        /**
         * Grant/Ungrant one asset to the user with one click of the checkbox
         * @param {Object} - access
         */
        grantOne(access) {
            // switch off the notification when the asset is not granted to the user
            if (!access['is_selected']) {
                access['is_notified'] = false;
            }
        },
        /**
         * Grant/Ungrant all assets from one facility to the user with one click of the checkbox
         * @param {Object} - facility
         */
        grantAll(facility) {
            // if the "Grant All" checkbox is not ticked
            // then untick the checkboxes and toggles from the same facility
            if (!facility['select_all']) {
                facility['accesses'].forEach(access => {
                    access['is_selected'] = false;
                    access['is_notified'] = false;
                });
            } else {
                facility['accesses'].forEach(access => {
                    access['is_selected'] = true;
                });
            }
        },
        /**
         * Pass the accesses list to parent component when the form is selected
         */
        onSelect() {
            const rawAccesses = JSON.parse(
                JSON.stringify(this.grantAccessList)
            );
            // define a list which contains all the selected access
            let selectedAccesses = [];
            // filter the accesses list and only picks the element with field 'is_selected' is true
            if (rawAccesses) {
                rawAccesses.forEach(facility => {
                    facility['accesses'].forEach(access => {
                        if (access['is_selected']) {
                            selectedAccesses.push({
                                access_id: access['access_id'],
                                facility_id: facility['facility_id'],
                                facility_name: facility['facility_name'],
                                asset_id: access['asset_id'],
                                asset_name: access['asset_name'],
                                is_notified: access['is_notified']
                            });
                        }
                    });
                });
            }
            this.grantAccessList = [];
            // return the selectedAccesses to the parent component
            this.$emit('close', selectedAccesses);
        },
        /**
         * Triggered when the Close button is clicked
         */
        onClose() {
            // Reset the access list
            this.initGrantAccessList();
            this.$emit('close', []);
        }
    }
};
</script>

<style lang="scss" scoped>
.permission-card-section {
    padding: 2px;
}
</style>
